import { useBorrowerBaseUrl } from 'core/hooks'

const useBorrowerUrl = url => {
  const baseUrl = useBorrowerBaseUrl()
  return url ? `${baseUrl}${url}` : baseUrl
}

export default useBorrowerUrl
